class Card {

    constructor(el) {
        this.card = el;
        this.btn = this.card.find('[data-card-btn]');
        this.info = this.card.find('[data-card-info]');
        this.infoClose = this.info.find('[data-card-info-close]');
        this.countBtn = this.card.find('[data-card-color-count-btn]');
        this.count = this.card.find('[data-card-color-count]');
        this.closeCount = this.count.find('[data-card-color-count-close]');
        this.color = this.card.find('[data-card-color]');
        this.images = this.card.find('[data-swap-img]');
        this.href = this.card.find('[data-card-href]');
        this.name = this.card.find('[data-card-name]');
        this.price = this.card.find('[data-card-price]');
        this.sizeCheckbox = this.card.find('[data-card-info-checkbox]');
        this.body = this.card.find('[data-card-body]');
        this.picture = this.card.find('[data-swap-picture]');
        this.pictureTo = this.card.find('[data-swap-picture-to]');
        this.topParts = this.card.find('[data-card-top]');
        this.bottomParts = this.card.find('[data-card-bottom]');
        this.selectedColor = this.card.find('[data-card-color].active');
        this.selectedColorId = null;
        this.hoveredColorId = null;
        this.imgPagination = this.card.find('[data-card-img-pag] picture');
        this.imgSwap = this.card.find('[data-card-img-swap]');
        this.imgComplectsPagination = this.card.find('[data-card-complects-img-pag] picture');
        this.imgOriginal = this.card.find('[data-card-original-img]');
    }

    initialize() {
        const that = this;

        this.setDefaults();

        this.card.hover(
            function () { $(this).addClass('active') },
            function () { $(this).removeClass('active') }
        )

        this.imgPagination.hover(
            function () {
                if (!$(this).closest(that.imgComplectsPagination).length) {
                    that.imgPagination.removeClass('card__active-img');
                    $(this).addClass('card__active-img');
                    that.imgSwap.html('<picture>' + $(this).html() + '</picture>');
                }
            }
        )

        this.imgComplectsPagination.hover(
            function () {
                that.imgPagination.removeClass('card__active-img');
                $(this).addClass('card__active-img');

                const $activeTopPart = that.topParts.filter('.active');
                const hoverImgSrc = $(this).find('img').attr('src');

                if ($activeTopPart.length && hoverImgSrc) {
                    const $imgInSwap = $activeTopPart.find(that.imgSwap).find('picture img');
                    if ($imgInSwap.length) {
                        $imgInSwap.attr('src', hoverImgSrc);
                    }

                    const $sourceInSwap = $activeTopPart.find(that.imgSwap).find('picture source[data-picture-desktop]');
                    if ($sourceInSwap.length) {
                        $sourceInSwap.attr('srcset', hoverImgSrc);
                    }
                }
            },
            function () {
                that.imgPagination.removeClass('card__active-img');
                $(that.imgPagination[0]).addClass('card__active-img');

                const $activeTopPart = that.topParts.filter('.active');
                const originalImgSrc = $activeTopPart.find(that.imgOriginal).data('card-original-img');

                if ($activeTopPart.length && originalImgSrc) {
                    const $imgInSwap = $activeTopPart.find(that.imgSwap).find('picture img');
                    if ($imgInSwap.length) {
                        $imgInSwap.attr('src', originalImgSrc);
                    }

                    const $sourceInSwap = $activeTopPart.find(that.imgSwap).find('picture source[data-picture-desktop]');
                    if ($sourceInSwap.length) {
                        $sourceInSwap.attr('srcset', originalImgSrc);
                    }
                }
            }
        )

        this.btn.on('click', function (e) {
            e.preventDefault();
            const _this = $(this);
            const ww = $(window).width();

            // if (ww >= 1024) {
            //     alert(2)
            //     if (!that.info.html()) {
            //         let productId = _this.data('product-id');
            //         that.card.find(`[data-card-color=${productId}]`).first().click();
            //     }

            //     // _this
            //     //     .attr('disabled', true)
            //     //     .addClass('btn--disabled');
            // } else if (!_this.attr('disabled')) {
            let offerId = _this.attr('data-offer-id');

            /** Retail Rocket */
            try { rrApi.addToBasket(offerId) } catch (e) { }

            if (offerId && (typeof window.Basket !== 'undefined')) {
                const date = new Date();

                const options = {
                  timeZone: 'Europe/Moscow',
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                  hour12: false
                };
                
                const formatter = new Intl.DateTimeFormat('en-CA', options);
                const parts = formatter.formatToParts(date);
                
                const year = parts.find(p => p.type === 'year').value;
                const month = parts.find(p => p.type === 'month').value;
                const day = parts.find(p => p.type === 'day').value;
                const hour = parts.find(p => p.type === 'hour').value;
                const minute = parts.find(p => p.type === 'minute').value;
                const second = parts.find(p => p.type === 'second').value;
                
                const timestamp = `${year}-${month}-${day}T${hour}:${minute}:${second}+03:00`;

                const settings = {
                    async: true,
                    crossDomain: true,
                    url: 'https://apptracking.retailrocket.ru/2.0/addToBasket?apiKey=4dcb7bd63a4c14c3af162d6d&partnerId=61406f9d97a5253590e1ea94',
                    method: 'POST',
                    headers: {
                        accept: 'text/plain',
                        'Content-type': 'application/json'
                    },
                    processData: false,
                    data: '{"link":{"name":"session","value":"' + BX.bitrix_sessid() + '"},"productId":' + offerId + ',"timestamp":"' + timestamp + '"}'
                };
    
                // console.log(settings);
    
                $.ajax(settings).done(res => {
                    console.log(res);
                });

                window.Basket.add(
                    offerId,
                    1,
                    function () {
                        if (typeof window.miniCart !== 'undefined') {
                            window.miniCart.refreshMiniCart();
                        }
                    }
                );
            }
            // }
        });

        this.countBtn.on('click', function (e) {
            e.preventDefault();
            that.count.addClass('show');
        });

        this.closeCount.on('click', function (e) {
            e.preventDefault();
            that.count.removeClass('show');
        });

        this.color.on('click', function (e) {
            e.preventDefault();
            let activeColorPid = $(this).attr('data-card-color');
            that.card.find('[data-card-btn]').attr('data-product-id', activeColorPid);
            that.card.find('.checkbox__input').prop('checked', false);
            that.sendProductRequest(
                {
                    pid: activeColorPid,
                },
                'SET_COLOR'
            );
        });

        this.color.hover(function () {
            that.hoveredColorId = $(this).data('card-color');
            that.changeCardView();
        }, function () {
            that.hoveredColorId = that.selectedColorId;
            that.changeCardView();
        });

        this.color.on('click', function () {
            that.selectedColorId = $(this).data('card-color');
            that.hoveredColorId = that.selectedColorId;
            that.color.removeClass('active');
            $(this).addClass('active');
            that.changeCardView();
        });

        this.images.on('mouseenter mouseleave', function () {
            let el = $(this);
            let img = $(this).find('[data-src]');
            let src = img.attr('src');
            let swap = el.attr('data-swap-img');

            img.attr('src', swap);
            el.attr('data-swap-img', src);
        });

        this.picture.on('mouseenter', function () {
            that.picture.removeClass('active');
            that.pictureTo.addClass('active');
        });

        this.pictureTo.on('mouseleave', function () {
            that.pictureTo.removeClass('active');
            that.picture.addClass('active');
        });

        this.initSizeCheckbox();
    }

    setDefaults() {
        this.selectedColorId = this.selectedColor.data('card-color');
        this.hoveredColorId = this.selectedColorId;
    }

    changeCardView() {
        const that = this;

        this.topParts.removeClass('active');
        this.topParts.each(function () {
            if (parseInt($(this).data('product')) === parseInt(that.hoveredColorId)) $(this).addClass('active');
        });

        this.bottomParts.removeClass('active');
        this.bottomParts.each(function () {
            if (parseInt($(this).data('product')) === parseInt(that.hoveredColorId)) $(this).addClass('active');
        });
    }

    /**
     * Запрос данных о товаре
     * Обновление информации в карточке
     *
     * @param requestData
     * @param type
     */
    sendProductRequest(requestData, type) {
        const that = this;

        // if (type === 'SET_SIZE')
        // $('body').addClass('body--loading');

        $.ajax({
            url: '/local/ajax/quick_view.php',
            method: 'GET',
            dataType: 'json',
            data: requestData
        }).done(function (response) {
            // $('body').removeClass('body--loading');
            that.btn.text('Выберите размер');

            switch (type) {
                case 'SET_COLOR':
                    that.setColor(response.product);
                    break;

                case 'SET_SIZE':
                    that.setSize(response.product);

                    if (response.product.sku) {
                        that.btn.attr('data-offer-id', response.product.sku);
                        that.btn.text('Добавить в корзину');
                    }
                    break;
            }

        }).fail(function () {
            // $('body').removeClass('body--loading');
        });
    }

    /**
     * Смена цвета
     *
     * @param product
     */
    setColor(product) {
        let imgDesktop = product.gallery[0]?.imgDesktop;
        let imgTablet = product.gallery[0]?.imgTablet;
        let imgMobile = product.gallery[0]?.imgMobile;
        let imgSwapDesktop = product.gallery[1]?.imgDesktop;

        let imgNode = this.card.find('[data-card-img]');

        if (imgNode.find('[data-card-original-img]').length === 0) {
            imgNode.find('[data-picture-desktop]').attr('srcset', imgDesktop);
            imgNode.find('[data-picture-tablet]').attr('srcset', imgTablet);
            imgNode.find('[data-picture-mobile]').attr('srcset', imgMobile);
            imgNode.find('[data-swap-picture]').find('img').attr('src', imgDesktop).attr('data-src', imgDesktop);
            imgNode.find('[data-swap-picture-to]').find('source').attr('srcset', (imgSwapDesktop ? imgSwapDesktop : imgDesktop));
            imgNode.find('[data-swap-picture-to]').find('img').attr('src', imgDesktop).attr('data-src', imgDesktop);
        }

        this.color.removeClass('active');
        this.card.find(`[data-card-color=${product.id}]`).addClass('active');

        this.href.attr('href', product.url);
        this.name.text(product.productName);

        this.btn.attr('data-product-id', product.id);
        this.btn.attr('data-offer-id', '');

        this.infoClose.click();

        if (product.badge) {
            this.card.find('.card__badges').removeClass('d-none');
            this.card.find('.card__badges-item').text(product.badge);
        } else {
            this.card.find('.card__badges').addClass('d-none');
        }

        if (product.priceSale.formatted) {
            this.price.html(`
                <span class="card__price-current color--guardsman-red">
                    ${product.priceSale.formatted}
                </span>

                <span class="card__price-old">
                    ${product.priceBase.formatted}
                </span>
            `);
        } else {
            this.price.html(`
                <span class="card__price-current">
                    ${product.priceBase.formatted}
                </span>
            `);
        }

        if (product.sustainable) {
            this.card.find('.ecolabel').removeClass('d-none');
        } else {
            this.card.find('.ecolabel').addClass('d-none');
        }

        let selectSizeHtml = '';

        if (product.sizes[1].value) {
            selectSizeHtml += `
                <div class="card__info-inner__title">Размер</div>

                <div class="card__info-inner__body" data-card-body="size">
            `
            product.sizes.forEach((element) => {
                if (element.value !== '00') {
                    selectSizeHtml += this.sizeHtmlTemplate(element.value);
                }
            });

            selectSizeHtml += `
                </div>
            `;
        }

        if (product.length[1].value) {
            selectSizeHtml += `
                <div class="card__info-inner__title">Длина</div>
                <div class="card__info-inner__body" data-card-body="length">
            `
            product.length.forEach((element) => {
                if (element.value !== '00') {
                    selectSizeHtml += this.sizeHtmlTemplate(element.value);
                }
            });
            selectSizeHtml += `
                </div>
            `;
        }

        if (selectSizeHtml) {
            this.info.html(selectSizeHtml);

            this.initInfoClose();
            this.initSizeCheckbox();
        }

        this.card.find('[data-favorites-add]').attr('data-product-id', product.id);

        this.card.find('[data-favorites-delete]')
            .removeAttr('data-favorites-delete')
            .attr('data-favorites-add', '')
            .attr('data-product-id', product.id)
            .removeClass('active');

        if (typeof window.Favorites !== 'undefined') {
            window.Favorites.initLinks();
        }

        let productImgHtml = '';
        let gallery = product.gallery;
        this.card.find('[data-card-img-pag]').html('');
        gallery.map((image) => {
            const isComplects = this.card.find('[data-card-img-pag]').closest('[data-card-complects-img-pag]').length > 0;
        
            if (isComplects) {
                console.log('image.imgDesktop');
                console.log(image.imgDesktop);
                productImgHtml += `<picture>
                    <source srcset="${image.imgDesktop}"
                        media="(min-width: 1200px)" data-picture-desktop>
                    <source srcset="${image.imgTablet}"
                        media="(min-width: 768px)" data-picture-tablet>
                    <source srcset="${image.imgMobile}"
                        media="(min-width: 0px)" data-picture-mobile>
                    <img src="${image.imgDesktop}" width="1" height="1">
                </picture>`;
            } else {
                productImgHtml += `<picture>
                    <source srcset="${image.imgDesktop}"
                        media="(min-width: 1200px)" data-picture-desktop>
                    <source srcset="${image.imgTablet}"
                        media="(min-width: 768px)" data-picture-tablet>
                    <source srcset="${image.imgMobile}"
                        media="(min-width: 0px)" data-picture-mobile>
                    <img class="lazyload" src="/local/frontend/build/assets/images/example/load.webp"
                        width="1" height="1"
                        data-src="${image.imgDesktop}">
                </picture>`;
            }
        });
        this.card.find('[data-card-img-pag]').html(productImgHtml);

        this.card.find('[data-card-img-pag] picture').hover(
            function () {
                if (!$(this).closest('[data-card-complects-img-pag] picture').length) {
                    $(this).siblings().removeClass('card__active-img');
                    $(this).addClass('card__active-img');
                    imgNode.find('[data-card-img-swap]').html('<picture>' + $(this).html() + '</picture>');
                }
            }
        )

        if (this.card.find('[data-card-complects-img-pag] picture').length) {
            this.card.find('[data-card-complects-img-pag] picture').hover(
                function () {
                    $(this).siblings().removeClass('card__active-img');
                    $(this).addClass('card__active-img');
    
                    const $activeTopPart = $(this).parents('.card__top.active');
                    const complectImgSwap = $activeTopPart.find('[data-card-img-swap]');
                    const hoverImgSrc = $(this).find('img').attr('src');
    
                    if ($activeTopPart.length && hoverImgSrc) {
                        const $imgInSwap = complectImgSwap.find('picture img');
                        if ($imgInSwap.length) {
                            $imgInSwap.attr('src', hoverImgSrc);
                        }
    
                        const $sourceInSwap = complectImgSwap.find('picture source[data-picture-desktop]');
                        if ($sourceInSwap.length) {
                            $sourceInSwap.attr('srcset', hoverImgSrc);
                        }
                    }
                },
                function () {
                    const $activeTopPart = $(this).parents('.card__top.active');
                    const complectImgSwap = $activeTopPart.find('[data-card-img-swap]');
                    const originalImgSrc = $activeTopPart.find('[data-card-original-img]').data('card-original-img');
            
                    if ($activeTopPart.length && originalImgSrc) {
                        const $imgInSwap = complectImgSwap.find('picture img');
                        if ($imgInSwap.length) {
                            $imgInSwap.attr('src', originalImgSrc);
                        }
            
                        const $sourceInSwap = complectImgSwap.find('picture source[data-picture-desktop]');
                        if ($sourceInSwap.length) {
                            $sourceInSwap.attr('srcset', originalImgSrc);
                        }
                    }

                    const $allPictures = $activeTopPart.find('[data-card-complects-img-pag] picture');
                    $allPictures.removeClass('card__active-img');
                    $allPictures.first().addClass('card__active-img');
                }
            )
        }
    }

    /**
     * Навешивание обработчика на кнопки закрытия блока с выбором размера
     */
    initInfoClose() {
        const that = this;

        this.infoClose = this.info.find('[data-card-info-close]');

        this.infoClose.on('click', function (e) {
            e.preventDefault();

            that.btn
                .attr('data-card-btn', '')
                .removeClass('btn--disabled')
                .attr('disabled', false);
        });
    }

    /**
     * Навешивание обработчика на кнопки выбора размера
     */
    initSizeCheckbox() {
        const that = this;
        this.sizeCheckbox = this.card.find('[data-card-info-checkbox]');
        this.body = this.card.find('[data-card-body]');

        this.info.each(function () {
            that.body = $(this).find('[data-card-body]');
        });

        this.sizeCheckbox.on('click', function (e) {
            e.preventDefault();

            let el = $(this);
            let input = el.find('input');
            let inputValue = input.val();
            // let preloader = `<div class="loader"></div>`;
            // $(this).find('.checkbox__text').html(preloader);

            if (input.attr('disabled') === undefined) {
                let body = el.closest('[data-card-body]');
                let isInputChecked = input.prop('checked');

                body.find('[data-card-info-checkbox]').find('input').prop('checked', false);
                body.find('label').removeClass('checked');

                that.btn.attr('data-offer-id', '');

                input.prop('checked', !isInputChecked);
                let checkedInputs = {
                    pid: that.card.find('[data-card-btn]').attr('data-product-id'),
                };
                that.body.each((i) => {
                    let el = $(that.body[i]);
                    let checkboxes = el.find('[data-card-info-checkbox]');
                    let type = el.data('card-body');
                    checkboxes.each((i) => {
                        let curInput = $(checkboxes[i]).find('input');

                        if (curInput.prop('checked')) {
                            checkedInputs[type] = curInput.val();
                        }
                    });
                });

                that.sendProductRequest(
                    checkedInputs,
                    'SET_SIZE'
                );

                if (Object.keys(checkedInputs).length > that.body.length) {
                    that.btn
                        .removeClass('btn--disabled')
                        .attr('disabled', false);
                } else {
                    that.btn
                        .addClass('btn--disabled')
                        .attr('disabled', true);
                }
            }
            // $(this).find('.checkbox__text').html(inputValue);
        });
    }

    /**
     * Шаблон кнопки выбора размера
     *
     * @param size
     * @returns {string}
     */
    sizeHtmlTemplate(size) {
        return `
            <div class="card__info-inner__checkbox" data-card-info-checkbox>
                <label class="checkbox checkbox--size checkbox--size-round">
                    <input
                        class="checkbox__input"
                        type="checkbox"
                        name="checkbox"
                        value="${size}"
                        data-input>

                    <div class="checkbox__text" data-checkbox-text>
                        ${size}
                    </div>
                </label>
            </div>
        `;
    }

    /**
     * Выбор размера
     *
     * @param product
     */
    setSize(product) {
        const that = this;

        this.body.each((i) => {
            let el = $(that.body[i]);
            let checkboxes = el.find('[data-card-info-checkbox]');
            let type = ((el.data('card-body') === 'size') ? 'sizes' : 'length');

            checkboxes.each((i) => {
                let input = $(checkboxes[i]).find('input');

                product[type].forEach((size) => {
                    if (size.value === input.val()) {
                        if (size.selectable) {
                            input
                                .removeClass('checkbox-disabled')
                                .attr('disabled', false);
                        } else {
                            input
                                .addClass('checkbox-disabled')
                                .attr('disabled', true);
                        }
                    }
                });
            });
        });
    }
}

export { Card }

/**
 * Проверка выводить или нет информацию о скрытых цветах
 */
window.checkCardCountButtons = function () {
    const ww = $(window).width();

    $('[data-card-color-count-btn]').each(function () {
        let _this = $(this);

        if (ww >= 1200) {
            _this.toggleClass('hidden', !_this.data('count'));
        } else {
            _this.toggleClass('hidden', !_this.data('count-sm'));
        }
    });
}

$(window).on('load', function () {
    let cards = [];

    if ($('[data-card]').length > 0) {
        $('[data-card]').each(function (i) {
            cards[i] = new Card($(this));
            cards[i].initialize();
        });

        checkCardCountButtons();

        $(window).on('resize', function () {
            checkCardCountButtons();
        });
    }
});
